import { render, staticRenderFns } from "./TeacherComponent.vue?vue&type=template&id=0caae83e&"
import script from "./TeacherComponent.vue?vue&type=script&lang=js&"
export * from "./TeacherComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports